import { Outlet } from 'react-router-dom';

import { useAppSelector } from '@/app/hooks';
import { CommandK } from '@/components';
import { LoginPage } from '@/pages/login';

export const ProtectedRoutes = () => {
  const { me } = useAppSelector((state) => state.authentication);

  return me?.adUserId ? (
    <>
      <Outlet />
      <CommandK />
    </>
  ) : (
    <>
      <LoginPage />
    </>
  );
};
